import { ON_CHANGE_MODAL} from "../actions/types";

export const modalOnchangeActionFunction = ({ props, value }) => {
  return {
    type: ON_CHANGE_MODAL,
    payload: { props, value },
  };
};